import { MeasurementsListContainer } from '../containers/MeasurementsListContainer/index'
 
export const MeasurementsListPage = () => (
    <MeasurementsListContainer/>
)